import { PictureOutlined } from '@ant-design/icons';
import {
  parseApiClientFullResponse,
  useGetBackListeElettoraliIdImmagine,
} from '@framework/api-client';
import { useImageObjectUrl } from '@framework/common-web';
import { LoaderSpin } from '@framework/ui';

export interface IElectoralListChooserListImageProps {
  listId: string;
  alt?: string;
}

export function ElectoralListChooserListImage({
  listId,
  alt,
}: Readonly<IElectoralListChooserListImageProps>) {
  const { data: imageRawResponse, isFetching, isError } =
    useGetBackListeElettoraliIdImmagine(listId, {
      query: { retry: false, staleTime: 5 * 60 * 1000 },
      request: { fullResponse: true, responseType: 'arraybuffer' as const },
    });
  const { data: imageBytes, headers } =
    parseApiClientFullResponse(imageRawResponse);
  const url = useImageObjectUrl(
    imageBytes,
    headers?.getContentType()?.toString(),
    isError,
  );

  const renderContent = () => {
    if (isFetching) {
      return <LoaderSpin size="small" noPadding />;
    }
    if (url) {
      return (
        <img
          src={url}
          alt={alt ?? ''}
          style={{ maxHeight: '100%', maxWidth: 120, objectFit: 'contain' }}
        />
      );
    }
    return (
      <PictureOutlined style={{ fontSize: 64, opacity: 0.35 }} aria-hidden />
    );
  };

  return (
    <div
      style={{
        height: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {renderContent()}
    </div>
  );
}
